<template>
  <div>
    <base-card>
      <base-question text="Informe o nome da categoria" class="mb_15" />
      <base-input
        ref="itemName"
        autoFocus
        :label="StringLanguage.categoryName"
        class="mb_0"
        v-model="targetItem.name"
        :valid="!emptyNameError"
      />
    </base-card>

    <base-card v-if="!targetItem._id">
      <base-question text="Essa categoria possui tamanhos?" />
      <div class="d-flex">
        <div
          class="select-size mr_7"
          :class="targetItem.sizes.length === 1 ? 'active' : ''"
          @click.prevent="initSizes(1)"
        >
          <i :class="`fal ${getIcon(targetItem.mode)}`" id="unique"></i>
          <p>Tamanho único</p>
        </div>
        <div
          class="select-size ml_7"
          :class="targetItem.sizes.length > 1 ? 'active' : ''"
          @click.prevent="initSizes(2)"
        >
          <div>
            <i :class="`fal ${getIcon(targetItem.mode)} mr_5`"></i>
            <i :class="`fal ${getIcon(targetItem.mode)} mr_5`"></i>
            <i :class="`fal ${getIcon(targetItem.mode)}`"></i>
          </div>
          <p>Vários tamanhos</p>
        </div>
      </div>
    </base-card>
  </div>
</template>

<script>
import Vue from "vue";
// components
import BaseCard from "@/components/Card";
import BaseQuestion from "@/components/Question";
import BaseInput from "@/components/Input";
// libs
import Builder from "easyjs/lib/Schema/Components/Builder";

export default {
  components: {
    BaseCard,
    BaseQuestion,
    BaseInput,
  },
  data() {
    return {
      emptyNameError: false,
    };
  },
  props: {
    targetItem: { default: {} },
  },
  methods: {
    getIcon(mode) {
      const icons = {
        pizza: "fa-pizza-slice",
        drink: "fa-wine-glass-alt",
        step: "fa-soup",
      };

      return icons[mode];
    },
    isValidField(_id, field) {
      return !this.errors[_id] || this.errors[_id].indexOf(field) == -1;
    },
    initSizes(numOfSize) {
      if (!this.targetItem) {
        return;
      }

      const sizeArray = [];

      for (let x = 0; x < numOfSize; x++) {
        let size = Builder.factory("Size");
        size.new = true;
        size._id = Builder.generateRandomId("_");
        size.parent = this.targetItem._id;
        
        if (numOfSize == 1) {
          size.name = "Tamanho único";
        }

        sizeArray.push(size);
      }

      Vue.set(this.targetItem, "sizes", sizeArray);
    },
  },
};
</script>

<style scoped>
.select-size {
  flex: 1;
  max-width: 50%;
  min-width: calc(50% - 15px);
  height: 95px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  background-color: var(--box-up);
  color: var(--label-primary);
  cursor: pointer;
  transition: color linear 0.15s;
}
.select-size:hover,
.select-size.active {
  color: var(--default);
}
.select-size i:first-child {
  font-size: 12px;
}
.select-size i {
  font-size: 16px;
  margin-bottom: 10px;
}
.select-size i:last-child,
.select-size i#unique {
  font-size: 20px;
}
</style>